import { useEffect, useState } from 'react';

export const enum Screen {
  default,
  sm,
  md,
  lg,
  xl,
  xxl,
  xxxl,
}

// IMPORTANT: screen size breakpoints are defined in shared/styles/_breakpoints.scss
function getScreenSize(width: number): Screen {
  if (width < 480) return Screen.default;
  if (width >= 480 && width < 768) return Screen.sm;
  if (width >= 768 && width < 1024) return Screen.md;
  if (width >= 1024 && width < 1280) return Screen.lg;
  if (width >= 1280 && width < 1440) return Screen.xl;
  if (width >= 1440 && width < 1920) return Screen.xxl;
  else return Screen.xxxl;
}

export function useScreenSize() {
  const [screen, setScreen] = useState<Screen>(Screen.sm);
  const updateScreenSize = () => setScreen(getScreenSize(window.innerWidth));

  useEffect(() => {
    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  return screen;
}

export default useScreenSize;
